<form [formGroup]="form">
    <div class="ods-form-field">
        <div class="amount-input">
            <span class="dollar">$</span>
            <input 
                class="ods-text-input" 
                appDecimalNumberFormat 
                pattern="^\d+(\.\d+)?$" 
                type="text" 
                autocomplete="off"
                maxlength="9"
                formControlName="dollarAmount"
                name="dollarAmount"
            />
        </div>
    </div>
</form>